import classNames from 'classnames'
import * as React from 'react'
import type {HTMLAttributes} from 'react'

import {ExpandHandle} from '../../../../IndentedExpandHandle/IndentedExpandHandle'

import styles from './ExpandableGroup.css'

type Props = {
  id: string
  className?: string
  headerClassName?: string
  headerProps?: HTMLAttributes<HTMLDivElement> & {'data-overflow-title'?: string}
  heading: React.ReactNode
  content?: React.ReactNode
  expanded: boolean
  onToggle: (id: string, expanded: boolean) => unknown
}

function ExpandableGroup({
  id,
  heading,
  content,
  expanded,
  onToggle,
  className,
  headerClassName,
  headerProps,
}: Props) {
  const handleToggle = React.useCallback(() => onToggle(id, !expanded), [onToggle, id, expanded])
  const empty = content == null
  return (
    <div className={classNames(className, styles.container)}>
      <div
        className={classNames(styles.header, headerClassName)}
        role="presentation"
        onClick={!empty ? handleToggle : undefined}
        {...headerProps}
      >
        <ExpandHandle
          expandable={!empty}
          expanded={expanded}
          iconClassName={styles.icon}
          className={styles.expandHandle}
        />
        {heading}
      </div>
      {expanded ? content : null}
    </div>
  )
}

export default React.memo(ExpandableGroup)
